import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Paper,
  ListItemText,
  IconButton,
  Autocomplete,
  CircularProgress,
  TextField,
  MenuItem,
  Backdrop,
  Popover,
  Tooltip,
  Skeleton,
  Stack,
  Fade,
  Checkbox,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { visuallyHidden } from '@mui/utils';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { Clear, LocalPrintshop, MoreVert, Share, MarkEmailUnread, EditOff, ArrowCircleRight } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import EditIcon from '@mui/icons-material/Edit';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import { API, graphqlOperation } from 'aws-amplify';
import { CloudDownload, CloudUpload } from '@mui/icons-material';
import DeleteCrDrNoteMaster from '../../components/modals/DeleteCrDrNoteMaster';
import DeleteSelectedCrDrNoteMaster from '../../components/modals/DeleteSelectedCrDrNoteMaster';
import { ThreeDot } from '../../components/DropDown/ThreeDot';
import DropDownForListing from '../../components/DropDown/DropDown';
import { useWarningModal } from '../../components/modals/AddUnits';
import { showWarningSnackbar } from '../../components/snackBar/snakbar';
import LinkList from '../../components/Buttons/linkList';
import { createDebouncedCallback } from '../../hooks/createDebouncedCallback';
import { DateRangeRsuite, MoneyTextFieldRange } from '../../components';
import { updateTitle } from '../../redux/reducers/titleSlice';
import PeriodDropDown from '../../components/DropDown/PeriodDropDown';
import {
  checkandopenpdf,
  defaultRowsPerPage,
  defaultRowsPerPageOptions,
  fetchAndPrintPDF,
  getDefaultSorting,
  handleFreeze,
} from '../../utils/common';
import { ShareModal } from '../../components/modals/Share';
import { useThemes } from '../../components/Theme/theme';
import { getTransactionMaster, listCrDrNoteMasterv2, listCrDrNoteMasterCount } from '../../graphql';
import { LedgerTransactionModalv2 } from '../LedgerTransaction';
import { formatUnixTimestamp } from '../../library/dayJs';
import pdfImage from '../../assets/images/attachments/pdf.png';
import { TableCell } from '../../components/Table/TableCell';
import TableSearchButton from '../PrimeFigma/Components/TableSearchButton';
import RollingSoon from '../../components/Ui/RollingSoon';
import { SendEmailModalWrapper, useSendEmailModal } from '../../features/Email';

const headCell = [
  {
    id: 'CrDrNoteDate',
    numeric: false,
    disablePadding: true,
    label: 'Credit Note Date',
    width: '100px',
  },
  {
    id: 'CrDrNoteNumber',
    numeric: false,
    disablePadding: false,
    label: 'Credit Note No#',
    width: '150px',
  },
  // {
  //   id: "PartyInvoiceDate",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Party Invoice Date",
  //   width: "150px",
  // },
  {
    id: 'PartyInvoiceNumber',
    numeric: false,
    disablePadding: false,
    label: 'Party Invoice#',
    width: '50px',
  },
  {
    id: 'partyname',
    numeric: false,
    disablePadding: false,
    label: 'Party Name',
    width: '130px',
  },
  {
    id: 'Status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    width: '100px',
    disableSort: true,
  },
  {
    id: 'dueDateTimeStamp',
    numeric: false,
    disablePadding: false,
    label: 'DueDate',
    width: '100px',
  },
  {
    id: 'GrandTotalAmount',
    numeric: true,
    disablePadding: false,
    label: 'Amount (₹)',
    width: '100px',
  },
  // {
  //   id: "BalanceDueAmount",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Balance Due (₹)",
  //   width: "80px",
  // },
  {
    id: 'overDueDays',
    numeric: true,
    disablePadding: false,
    label: 'Due in/Over Due',
    width: '50px',
  },
  {
    id: 'Action',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    width: '100px',
  },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, onDelete, setEnableSearch, EnableSearch,setShowActions,showActions, scroll } = props;
  const { theme } = useThemes();

  console.log(scroll,"99999scroll")

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  function overDueFunction(label) {
    const [beforeSlash, afterSlash] = label.split('/');

    return (
      <span>
        <span style={{ color: 'green' }}>{beforeSlash}/</span>
        <span style={{ color: 'red' }}>{afterSlash}</span>
      </span>
    );
  }

  return (
    <TableHead>
      <TableRow
        sx={{
          '.MuiTableCell-root': {
            backgroundColor: `${theme.palette.background.tablebg} !important`,
            fontSize: '14px',
          },
          backgroundColor: 'background.tablebg',
          '.MuiTableCell-head': {
            backgroundColor: 'background.tablebg',
            padding: '2px 10px',
            borderBottom: '0px',
          },
          height: '35px',
        }}
      >
        <TableCell
          sx={{
            minWidth: '50px',
            padding: '2px 10px',
          }}
        >
          <Checkbox
            sx={{ color: 'input.border' }}
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all credit notes',
            }}
            size="small"
          />
        </TableCell>
        {headCell.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              minWidth: headCell.width,
              position: headCell.id === 'Action' ? 'sticky' : '',
              right: headCell.id === 'Action' ? 0 : '',
              // borderLeft: headCell.id === "Action" ? "1px solid" : "0px",
              whiteSpace: 'nowrap',
            }}
            //  sx={{maxWidth:headCell.width}}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: headCell.id === 'Action' ? 'center' : 'space-between',
                alignItems: 'center',
                flexDirection: headCell.numeric ? 'row-reverse' : '',
                // border: headCell.id === 'Action' ? '1px solid black' : '',
                borderRadius: headCell.id === 'Action' ? '3px' : '',
                width: '100%',
                backgroundColor: headCell.id === 'Action' ? 'white' : 'background.tablebg',
                boxShadow: (headCell.id === "Action") && (scroll) ?  "0px 4px 8px rgba(0, 0, 0, 0.6)" : "",
                 "&:active": 
                {
                  transform: scroll ? "scale(0.92)":"scale(1)",
                },
              }}
              onClick={(e) => {
                if(headCell.label === 'Actions'){
                    setShowActions((pre) => !pre)  
                  }
              }}
            >
              <>
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={headCell.id == 'Action' || headCell.disableSort ? null : createSortHandler(headCell.id)}
                  hideSortIcon={headCell.id === 'Action' || headCell.disableSort}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {headCell.id === 'overDueDays' ? overDueFunction(headCell.label) : headCell.label}
                    {orderBy === headCell.id ? (
                      <Box component="span" sx={visuallyHidden}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </Box>
                    ) : null}
                    {/* {headCell.id !== "Action" ? (
                      <SearchIcon
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setEnableSearch((prev) => !prev);
                        }}
                        sx={{ marginLeft: "10px" }}
                        fontSize="small"
                      />
                    ) : null} */}
                    {
                        (headCell.label === 'Actions') ? 
                          <ArrowCircleRight
                          sx={{
                            transition: 'transform 0.3s ease-in-out',
                            marginLeft: '10px',
                            transform : scroll ? (!showActions ?  'rotate(0deg)' : 'rotate(180deg)') : "rotate(180deg)",
                            color:scroll ? (!showActions ? 'gray' : '#ee5b2b') : ('#ee5b2b'),
                          }}
                          
                          fontSize="small"
                        /> : null
                    }
                  </Box>
                </TableSortLabel>
              </>
            </Box>
          </TableCell>
        ))}
        {numSelected > 0 ? (
          <TableCell>
            <ThreeDot
              onDelete={() => {
                onDelete(true);
              }}
            />
          </TableCell>
        ) : null}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function AllCreditNote() {
  const { theme } = useThemes();

  const dispatch = useDispatch();
  dispatch(display());
  const navigate = useNavigate();
  const { defaultSortingColumn, defaultSortingOrder } = getDefaultSorting('crdrnote');
  const [order, setOrder] = useState(defaultSortingOrder);
  const [orderBy, setOrderBy] = useState(defaultSortingColumn);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  // Store latest values in refs to avoid stale closures
  const rowsPerPageRef = useRef(rowsPerPage);
  rowsPerPageRef.current = rowsPerPage;

  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [rows, setRows] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [circularOpen, setCircularOpen] = useState(true);
  const [filteredList, setFilteredList] = useState([]);
  const [itemData, setItemData] = useState({});
  const [deleteSelectedModal, setDeleteSelectedModal] = useState(false);
  const [ListSelection, setListSelection] = useState('All');
  const [shareOpen, setShareOpen] = useState(false);

  // Email functionality state
  const [emailSendingSelection, setEmailSendingSelection] = useState([]);
  const [individualEmailSelection, setIndividualEmailSelection] = useState([]);
  const { openModal, modalProps } = useSendEmailModal(['creditNote']);

  const defaultFilterColumns = {
    CrdrNoteDate: '',
    CrDrNoteNumber: '',
    PartyInvoiceDate: '',
    PartyInvoiceNumber: '',
    PartyName: '',
    Status: '',
    DueDate: '',
    GrandTotalAmount: '',
    AmountFrom: '',
    AmountTo: '',
    DueDateFrom: '',
    DueDateTo: '',
    BalanceDueAmount: '',
    overDueDays: '',
    CrdrNoteDateFrom: '',
    CrdrNoteDateTo: '',
  };
  const [filterColumns, setFilterColumns] = useState(defaultFilterColumns);
  const [showActions,setShowActions] = useState (true)
  const handleResetFilterColumns = (status) => (status === false ? setFilterColumns(defaultFilterColumns) : null);

  const filterColumnsRef = useRef(filterColumns);
  filterColumnsRef.current = filterColumns;
  const debouncedSearchRef = useRef(null);
  const [exportItem, setExportItem] = useState(null);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  // Click handler for the main box to open the popover
  const handleClickBox = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  // Click handler to close the popover
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Check if the popover should be open based on anchorEl
  const open = Boolean(anchorEl);

  // Options to display in the popover, each with a label and onClick handler
  const options = [
    // {
    //   label: 'Import',
    //   icon: <CloudDownload sx={{ color: 'blue' }} />,
    //   onClick: () => {},
    //   link: '/import-data',
    // },
    {
      label: 'Export',
      icon: <CloudUpload sx={{ color: '#ffa500' }} />,
      onClick: () => {
        if (rows.length > 0) {
          setExportModalOpen(true);
          setExportItem('Credit Note');
        } else {
          showWarningSnackbar('No data available for export.');
        }
      },
      link: '',
      rollingOutSoon: true
    },
    {
      label: 'Send Selected Credit Notes',
      icon: <MarkEmailUnread />,
      onClick: () => {
        handleBulkEmail();
      },
      link: '',
    },
  ];

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleBulkEmail = () => {
    if (Freeze === 1) {
      return handleFreeze();
    }
    if (emailSendingSelection.length > 0) {
      openModal(
        'creditNote',
        emailSendingSelection.map((note) => ({
          id: Number(note.crdrnoteid),
          recipientId: Number(note.partyid),
          email: note.partyemail,
          name: note.partydisplayname,
          invoiceNumber: note.crdrnotenumber,
        }))
      );
    } else {
      showWarningSnackbar('No Credit Notes selected. Please select at least one Credit Note to send the email.');
    }
    setShareOpen(false);
  };

  // Function to explicitly clear email selection
  const clearEmailSelection = () => {
    setEmailSendingSelection([]);
    setIndividualEmailSelection([]);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked && rows.length) {
      const newSelected = rows.map((n) => n.crdrnoteid);
      const newEmailSelection = rows.map((n) => ({
        crdrnoteid: n.crdrnoteid,
        partyid: n.partyid,
        partyemail: n.partyemail,
        consigneename: n.partydisplayname,
        crdrnotenumber: n.crdrnotenumber,
      }));

      setSelected(newSelected);
      setEmailSendingSelection(newEmailSelection);
      return;
    }
    setSelected([]);
    setEmailSendingSelection([]);
  };

  const handleClick = (event, row) => {
    const selectedIndex = selected.findIndex((item) => item === row.crdrnoteid);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row.crdrnoteid);
      const newEmailSelection = emailSendingSelection.concat({
        crdrnoteid: row.crdrnoteid,
        partyid: row.partyid,
        partyemail: row.partyemail,
        consigneename: row.partydisplayname,
        crdrnotenumber: row.crdrnotenumber,
      });
      setEmailSendingSelection(newEmailSelection);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      const newEmailSelection = emailSendingSelection.filter((item) => item.crdrnoteid !== row.crdrnoteid);
      setEmailSendingSelection(newEmailSelection);
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      const newEmailSelection = emailSendingSelection.filter((item) => item.crdrnoteid !== row.crdrnoteid);
      setEmailSendingSelection(newEmailSelection);
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
      const newEmailSelection = emailSendingSelection.filter((item) => item.crdrnoteid !== row.crdrnoteid);
      setEmailSendingSelection(newEmailSelection);
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    if (circularOpen) return;
    if (newPage > page) {
      if (rows.length !== dataCount)
        if (rows.length <= rowsPerPageRef.current * newPage) listCreditDebitMaster(false, rows.length, rowsPerPageRef.current);
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPageRef.current - rows.length) : 0;

  const filterBySearch = (event, category, value) => {
    setPage(0);
    let query = value ? value : event.target?.value;
    let name = category;
    const obj = { ...filterColumnsRef.current };
    if (name != 'GrandTotalAmount') {
      for (const key in obj) {
        if (key == name) {
          obj[key] = query;
        } else {
          // obj[key] = "";
        }
      }
    } else {
      obj['AmountFrom'] = query[0];
      obj['AmountTo'] = query[1];
    }
    setFilterColumns(obj);
  };

  useEffect(() => {
    setFilteredList(rows);
  }, [rows]);

  useEffect(() => {
    const controlAndS = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's') {
        e.preventDefault();
        // showErrorSnackbar("Nothing to save");
      }
    };

    window.addEventListener('keydown', controlAndS);

    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, []);

  let { WarningModal, handleOpen: setWarningOpen } = useWarningModal();
  let search = (obj) => {
    listCreditDebitMaster(true, 0, rowsPerPageRef.current, obj);
  };

  if (!debouncedSearchRef.current) {
    debouncedSearchRef.current = createDebouncedCallback(
      (obj) => {
        // Always use current values from refs
        const currentFilterColumns = filterColumnsRef.current;
        const currentRowsPerPage = rowsPerPageRef.current;

        // Check if there are any non-empty filter values
        const hasFilters = Object.values(currentFilterColumns).some((value) => value && value.toString().trim().length > 0);

        if (hasFilters) {
          listCreditDebitMaster(true, 0, currentRowsPerPage, currentFilterColumns);
        } else {
          listCreditDebitMaster(true, 0, currentRowsPerPage);
        }
      },
      500,
      false
    );
  }

  const filterSearch = useCallback((obj) => {
    debouncedSearchRef.current(obj);
  }, []);

  // Clear email selection when selected array is cleared
  useEffect(() => {
    // Only clear email selection if both selected and emailSendingSelection are empty
    // This prevents clearing email selection when individual Share button is clicked
    if (selected.length === 0 && emailSendingSelection.length === 0) {
      // Both are already empty, no need to do anything
    }
  }, [selected, emailSendingSelection]);

  const [limit, setlimit] = useState(rowsPerPageRef.current);

  const [filterColumnsMaxValues, setfilterColumnsMaxValues] = useState({
    GrandTotalAmount: 0,
  });
  useEffect(() => {
    API.graphql(
      graphqlOperation(listCrDrNoteMasterv2, {
        rowfrom: 0,
        limitno: 1,
        columnname: 'GrandTotalAmount',
        ordertype: 'DESC',
        searchmode: 0,
        searcharray: JSON.stringify([]),
        crdrnotetypecd: 'CreditNote',
      })
    ).then((res) => {
      console.log(res);
      setfilterColumnsMaxValues((prev) => ({ ...prev, GrandTotalAmount: res?.data?.listCrDrNoteMasterv2?.[0]?.grandtotalamount }));
    });
    return () => {};
  }, []);
  const [dataLoader, setDataLoader] = useState(true);
  async function listCreditDebitMaster(reset, from, to, filterColumn) {
    try {
      if (rows.length / rowsPerPageRef.current == page + 1) {
        setlimit(to);
      } else if (rows.length / rowsPerPageRef.current < 1) {
        setlimit(rowsPerPageRef.current - rows.length);
      }
      setCircularOpen(true);
      if (reset) {
        setRows([]);
        setPage(0);
      }
      let searchMode = 0;
      let SearchArray = [];
      filterColumn = filterColumn ? filterColumn : filterColumnsRef.current;
      switch (ListSelection) {
        case 'Active':
          SearchArray = [...SearchArray];
          break;
        case 'Cancelled':
          SearchArray = [...SearchArray];
          break;
        default:
          break;
      }
      // Handle AmountFrom and AmountTo together to avoid duplicates
      const amountFrom = filterColumn.AmountFrom || '';
      const amountTo = filterColumn.AmountTo || '';

      if (amountFrom || amountTo) {
        searchMode = 1;
        // Ensure From < To before adding to SearchArray
        const lowerAmount = Number(amountFrom < amountTo ? amountFrom : amountTo);
        const higherAmount = Number(amountFrom < amountTo ? amountTo : amountFrom);

        // Add both values with correct order
        SearchArray = [...SearchArray, { AmountFrom: lowerAmount }, { AmountTo: higherAmount }];
      } else if (amountFrom) {
        searchMode = 1;
        SearchArray = [...SearchArray, { AmountFrom: amountFrom }];
      } else if (amountTo) {
        searchMode = 1;
        SearchArray = [...SearchArray, { AmountTo: amountTo }];
      }

      Object.keys(filterColumn).map((key) => {
        if (filterColumn[key]?.toString()?.length > 0) {
          // Skip AmountFrom and AmountTo as they are handled above
          if (key !== 'AmountFrom' && key !== 'AmountTo') {
            searchMode = 1;
            SearchArray = [...SearchArray, { [key]: filterColumn[key] }];
          }
        }
      });

      let res = await Promise.all([
        await API.graphql(
          graphqlOperation(listCrDrNoteMasterv2, {
            rowfrom: from,
            limitno: to,
            columnname: orderBy,
            ordertype: order,
            searchmode: searchMode,
            searcharray: JSON.stringify(SearchArray),
            crdrnotetypecd: 'CreditNote',
          })
        ),
        await API.graphql(
          graphqlOperation(listCrDrNoteMasterCount, {
            rowfrom: from,
            limitno: to,
            columnname: orderBy,
            ordertype: order,
            searchmode: searchMode,
            searcharray: JSON.stringify(SearchArray),
            crdrnotetypecd: 'CreditNote',
          })
        ),
      ]);
      let count = res?.[1].data;
      let data = res?.[0].data;
      setdataCount(
        count.listCrDrNoteMasterCount[0]?.statuscode == null
          ? parseInt(count.listCrDrNoteMasterCount?.[0]?.crdrnotemasterlistcount || 0)
          : 0
      );
      let arr = [];
      let arrD = [];
      if (data?.listCrDrNoteMasterv2 != null) {
        arr = data.listCrDrNoteMasterv2.filter((elem) => elem.statuscode == null);
        arr.map((item) => {
          let from = new Date(Number(item.crdrnotedate) * 1000);
          let frommm = from.getMonth() + 1;
          let fromdd = from.getDate();

          if (fromdd < 10) fromdd = '0' + fromdd;
          if (frommm < 10) frommm = '0' + frommm;

          item.customerorsupplierid = {
            PartyID: item.partyid,
            partyAccountID: item.partyaccountid,
          };
          item.customerorsuppliertype = item.partytypecd;
          item.statuscd = item.receivedamount >= item.grandtotalamount ? 'Paid' : item.receivedamount === 0 ? 'Unpaid' : 'Partial';
          item.dueDate = formatUnixTimestamp(item.duedatetimestamp);
          item.balancedueamount = item.grandtotalamount - item.partamount;
          item.invno = [];
        });
      }
      let cArr = [...arr, ...arrD];
      if (reset) {
        setRows((prev) => [...cArr]);
        setFilteredList((prev) => [...cArr]);
        setCircularOpen(false);
      } else {
        setRows((prev) => [...prev, ...cArr]);
        setFilteredList((prev) => [...prev, ...cArr]);
        setCircularOpen(false);
      }
      setlimit(0);
      setCircularOpen(false);
    } catch (error) {
      setlimit(0);
      console.log(error);
    }
  }
  const [firstMount, setfirstMount] = useState({ current: true });
  useEffect(() => {
    if (firstMount.current) {
      setfirstMount({ current: false });
    }
  }, []);

  useEffect(() => {
    if (firstMount.current === false) {
      // Use the debounced search which will check current filterColumns
      filterSearch();
    }
    return () => {};
  }, [filterColumns, filterSearch]);

  var date = new Date(),
    y = date.getFullYear();
  var firstDay = new Date(y, 0, 1);
  var lastDay = new Date(y, 12, 0);
  const [ledgerModalStartDate, setLedgerModalStartDate] = useState(Math.floor(new Date(firstDay).getTime() / 1000));
  const [ledgerModalEndDate, setLedgerModalEndDate] = useState(Math.floor(new Date(lastDay).getTime() / 1000));
  const [modalData, setModalData] = useState([]);
  const [allModalData, setAllModalData] = useState([]);
  const [modalTableLength, setModalTableLength] = useState(0);
  const [accountName, setAccountName] = useState('');
  const [accountID, setAccountID] = useState('');
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [modalAccountDetails, setModalAccountDetails] = useState([]);
  const [dataCount, setdataCount] = useState(0);

  const getTransactiondata = (array) => {
    return new Promise((resolve) => {
      let ids = [];
      const items = [];
      array?.map(async (ele) => {
        if (!ids?.includes(ele?.TransactionID)) {
          ids.push(ele?.TransactionID);
          try {
            const resTransactionDetails = await API.graphql(
              graphqlOperation(getTransactionMaster, {
                TransactionID: ele?.TransactionID,
              })
            );
            items?.push({
              id: resTransactionDetails.data.getTransactionMaster?.TransactionID,
              typeCD: resTransactionDetails.data.getTransactionMaster.TransactionTypeCD,
              Vno: resTransactionDetails.data.getTransactionMaster.VoucherNumber,
            });
          } catch (error) {
            console.error('An error occurred while deleting a purchase line item:', error);
            // Handle the error or log it as needed.
          }
        }
      });

      setTimeout(() => {
        resolve(items);
      }, 2000);
    });
  };

  useEffect(() => {
    getUserPreferences();
  }, []);
  let userPreference = useSelector((state) => state.userPrefrenceandReducer);

  async function getUserPreferences() {
    try {
      setLedgerModalStartDate(userPreference?.financialYear?.StartDate);
      setLedgerModalEndDate(userPreference?.financialYear?.EndDate);
    } catch (error) {
      setBackdropOpen(false);
      console.log(error);
    }
  }

  const [state, setState] = useState({
    reason: '',
    errorFields: {
      reason: '',
    },
    errorStatus: {
      reason: false,
    },
  });

  useEffect(() => {
    setFilteredList([]);
    setRows([]);
    setPage(0);
    clearEmailSelection();
    setSelected([]);
    listCreditDebitMaster(true, 0, rowsPerPageRef.current);
    return () => {};
  }, [order, orderBy]);

  const [EnableSearch, setEnableSearch] = useState(false);

  useEffect(() => {
    if (firstMount.current === false) {
      if (rowsPerPageRef.current > rows.length) {
        listCreditDebitMaster(true, 0, rowsPerPageRef.current);
      } else {
      }
    }
    return () => {};
  }, [rowsPerPage]);
  const DateRangeRef = useRef(null);
  const containerRef = useRef(null);
  const openDateRange = () => {
    setEnableSearch(true);
    DateRangeRef?.current?.openDatePicker();
  };
    const crediTableRef = useRef(null)
     const [scroll,setScroll] = useState(false)

       useEffect(() => {
       if (rows.length > 0 && !circularOpen) {
         const width = crediTableRef.current?.offsetWidth;
         const screenWidth = window.innerWidth;
         if (width < (screenWidth - 50)) {
          setScroll(false)
         } else {
           setScroll(true);
         }
       }
     }, [rows, circularOpen]);

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  const [rolling, setRolling] = useState(false);

  return (
    <Box className="noTableCellBorder">
      <DeleteCrDrNoteMaster
        open={deleteModalStatus}
        storage={'purchase&expenses'}
        itemId={deleteId}
        setOpen={setDeleteModalStatus}
        itemData={itemData}
        rows={rows}
        setRows={setRows}
      />
      <DeleteSelectedCrDrNoteMaster
        open={deleteSelectedModal}
        setOpen={setDeleteSelectedModal}
        itemsData={selected}
        rows={rows}
        setRows={setRows}
      />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTopRightRadius: '12px',
          borderTopLeftRadius: '12px',
          padding: '8px 10px',
          backgroundColor: 'primary.main',
        }}
      >
        <Box sx={{ display: 'flex', flex: { xs: 1, sm: 0 } }}>
          {/* <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              padding: "6px 16px",
              backgroundColor: "primary.main",
              borderRadius: "12px",
              cursor: "pointer",
              color: "#fff",
              transition: "ease-in-out .4",
              ":hover": {
                backgroundColor: "primary.main",
                color: "#f1ededeb",
              },
            }}
            onClick={() => navigate("/alldebitnote")}
          >
            <RequestQuoteIcon sx={{ fontSize: "20px" }} />
            <Typography
              sx={{ fontSize: "12px", marginLeft: "5px", minWidth: 80 }}
            >
              Debit Note
            </Typography>
          </Box> */}
          <LinkList list="All Credits" link="/addcreditnote" add=" Add Credit Note" />
        </Box>

        {/* <Box
          sx={{
            display: {
              xs: "none",
              sm: "flex",
              md: "flex",
              lg: "flex",
              xl: "flex",
            },
          }}
        >
          <MUILink
            underline="none"
            color="inherit"
            href="/creditnote"
            // target="_blank"
          >
            <Button
              variant="outlined"
              color="inherit"
              sx={{
                color: "#fff",
                borderColor: "#fff",
                margin: "0px 10px",
                minWidth: "auto",
                textTransform: "capitalize",
              }}
            >
              Add Credit Note
            </Button>
          </MUILink>
        </Box> */}

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TableSearchButton
            setEnableSearch={setEnableSearch}
            EnableSearch={EnableSearch}
            id={'crediNoteSearch'}
            onClick={handleResetFilterColumns}
          />
          <Box
            sx={{
              display: {
                xs: 'none',
                sm: 'flex',
                md: 'flex',
                lg: 'flex',
                xl: 'flex',
                gap: '10px',
              },
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                width: '60%',
                m: 1,
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center',
                color: 'white',
                whiteSpace: 'nowrap',
              }}
            >
              Total : {dataCount} Item{dataCount !== 1 && 's'} {selected.length !== 0 ? `(Selected: ${selected.length}/${dataCount})` : ''}
            </Typography>
            <Box sx={{}}>
              <label
                style={{
                  color: '#818694',
                }}
              ></label>
              <DropDownForListing
                name={'ser'}
                value={ListSelection}
                onChange={(e) => {
                  let value = e.target.value;
                  setListSelection(value);
                  setFilterColumns((prev) => ({
                    ...prev,
                    CancelFlag: value != 'All' ? (value == 'Active' ? 0 : 1) : '',
                  }));
                }}
              />
            </Box>
            <PeriodDropDown
              custom={openDateRange}
              onChange={(start, end) => {
                setFilterColumns((prev) => ({
                  ...prev,
                  CrdrNoteDateFrom: start,
                  CrdrNoteDateTo: end,
                }));
              }}
              value={{
                start: filterColumns.CrdrNoteDateFrom,
                end: filterColumns.CrdrNoteDateTo,
              }}
            />
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                borderRadius: '5px',
                p: 1,
                cursor: 'pointer',
                '&:hover': {
                  borderColor: '#ccc',
                  backgroundColor: theme.palette.input.border || '#f5f5f5',
                },
              }}
              onClick={handleClickBox} // Toggle the popover on box click
            >
              <MoreVert sx={{ fontSize: '20px', color: '#fff' }} />

              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <Box sx={{ p: 1, minWidth: '200px' }}>
                  {
                      options.map((option,index) => 
                        option.rollingOutSoon ? 
                        (
                          <Typography
                            key={index}
                            onClick={() => {
                              handleClose();
                            }}
                            sx={{
                              padding: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              // '&:hover': {
                              //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                              // },
                            }}
                          >
                        <Tooltip 
                          title={<RollingSoon />}
                          placement="right"
                          PopperProps={{
                            sx: {
                              '& .MuiTooltip-tooltip': {
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                                padding: 0,
                              } 
                            }
                          }}
                        >      
                          <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {option.icon}
                              <span style={{ marginLeft: '8px', opacity: 0.5 }}>
                                {option.label}
                              </span>
                          </Box>
                        </Tooltip> 
                          </Typography>
                        ): 
                        (<Link style={{ textDecoration: 'none', color: 'inherit' }} to={option.link} state={{ fromLink: '/customerList' }}>
                            <Typography
                              key={index}
                              onClick={() => {
                                handleClose();
                                option.onClick();
                              }}
                              sx={{
                                cursor: 'pointer',
                                padding: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                // '&:hover': {
                                //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                                // },
                              }}
                            >
                              {option.icon}
                              <span style={{ marginLeft: '8px' }}>{option.label}</span>
                            </Typography>
                        </Link>)
                      )
                  }
                </Box>
              </Popover>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          // boxShadow: "inset 0 0 8px #d7d7d73b",
          boxShadow: 'rgb(33 35 38 / 10%) 0px 10px 10px -10px',
          borderBottomRightRadius: '12px',
          borderBottomLeftRadius: '12px',
          // backgroundColor: theme.palette.bodyGray.secondary,
          // borderRadius:'12px',
          padding: {
            // xs: "8px 12px",
          },
          '.css-1mxz8qt-MuiPaper-root': {
            boxShadow: 'none',
          },
          '.MuiTableCell-root': {
            padding: '1px 10px',
            fontSize: '13px',
          },
          '.MuiTableCell-head': {
            backgroundColor: 'background.tablebg',
            padding: '5px 10px',
            borderBottom: '0px',
          },
        }}
      >
        <Box sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}>
          <TableContainer
            ref={containerRef}
            className="custom-scrollbar"
            // sx={{
            //   // maxHeight: 400,
            //   scrollbarWidth: "thin",
            //   "&::-webkit-scrollbar": {
            //     width: "0em",
            //     height: "0.4em",
            //   },
            //   "&::-webkit-scrollbar-track": {
            //     background: `${theme.palette.primary.main}47`,
            //   },
            //   "&::-webkit-scrollbar-thumb": {
            //     backgroundColor: "primary.main",
            //   },
            //   "&::-webkit-scrollbar-thumb:hover": {
            //     background: `${theme.palette.primary.main}47`,
            //   },
            // }}
            sx={{
              height: {
                sm: 'calc( 100vh - 230px )',
                xs: 'calc( 100vh - 180px )',
              },
            }}
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              // sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={dense ? 'small' : 'medium'}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={dataCount}
                setEnableSearch={setEnableSearch}
                onDelete={() => setDeleteSelectedModal(true)}
                setShowActions = {setShowActions}
                showActions = {showActions}
                scroll = {scroll}
              />
              <TableBody ref= {crediTableRef}>
                <TableRow
                  sx={{
                    '.MuiTableCell-root': {
                      backgroundColor: 'transparent ',
                      borderBottom: 'none',
                    },
                    '.css-wrnu0i-MuiInputBase-root': {
                      fontSize: '13px',
                    },
                    '.css-xk0adg-MuiButtonBase-root-MuiIconButton-root': {
                      padding: '2px 4px',
                    },
                    '.css-1gqfvv-MuiPaper-root': {
                      boxShadow: 'none',
                      borderBottom: 'solid 1px rgba(0,0,0,0.24)',
                      borderRadius: '0px',
                    },
                    // visibility: !EnableSearch ? "collapse" : "visible",
                    display: !EnableSearch ? 'none' : 'content',
                  }}
                >
                  <TableCell></TableCell>
                  <TableCell>
                    <Paper
                      id="creditNoteSearch"
                      sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <DateRangeRsuite
                        ref={DateRangeRef}
                        containerRef={containerRef}
                        value={[
                          filterColumns.CrDrNoteDateFrom ? filterColumns.CrDrNoteDateFrom : null,
                          filterColumns.CrDrNoteDateTo ? filterColumns.CrDrNoteDateTo : null,
                        ]}
                        onChange={({ from, to }) => {
                          setFilterColumns((prev) => ({
                            ...prev,
                            CrDrNoteDateFrom: from ? from : '',
                            CrDrNoteDateTo: to ? to : '',
                          }));
                        }}
                        className="hide-input-outline hide-input-border"
                      />
                      {/* <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.CrDrNoteDateFrom !== '' || filterColumns.CrDrNoteDateTo != '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  CrDrNoteDateFrom: '',
                                  CrDrNoteDateTo: '',
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton> */}
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <InputBase
                        name="CrDrNoteNumber"
                        value={filterColumns.CrDrNoteNumber}
                        onChange={(e) => filterBySearch(e, 'CrDrNoteNumber')}
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: '0px' }}>
                        {filterColumns.CrDrNoteNumber !== '' ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                CrDrNoteNumber: '',
                              }));
                              setFilteredList(rows);
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <InputBase
                        name="partyInvoiceNumber"
                        value={filterColumns.PartyInvoiceNumber}
                        onChange={(e) => filterBySearch(e, 'PartyInvoiceNumber')}
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: '0px' }}>
                        {filterColumns.PartyInvoiceNumber !== '' ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                PartyInvoiceNumber: '',
                              }));
                              setFilteredList(rows);
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <InputBase
                        name="partyName"
                        value={filterColumns.PartyName}
                        onChange={(e) => filterBySearch(e, 'PartyName')}
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: '0px' }}>
                        {filterColumns.PartyName !== '' ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                PartyName: '',
                              }));
                              setFilteredList(rows);
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      {/* <InputBase
                          name="Status"
                          value={filterColumns.Status}
                          onChange={(e) => handleFilterBySearch(e, "Status")}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        /> */}

                      <Autocomplete
                        id={''}
                        disableClearable
                        options={['UNPAID', 'PAID', 'PARTIAL']}
                        isOptionEqualToValue={(option, value) => option == value}
                        clearIcon={filterColumns.Status !== '' ? <ClearIcon style={{ fontSize: '20px' }} /> : null}
                        value={filterColumns.Status}
                        // onChange={onChange}
                        onChange={(e, value) => filterBySearch(e, 'Status', value)}
                        size="small"
                        sx={{ height: '32px' }}
                        renderOption={(props, option) => (
                          <>
                            <MenuItem {...props} key={option} value={option}>
                              <ListItemText primary={option} />
                            </MenuItem>
                          </>
                        )}
                        renderInput={(params) => (
                          <TextField
                            sx={{
                              minWidth: '100px',
                              border: 'none', // Ensure border is removed
                              '& .MuiInput-underline:before': {
                                borderBottom: 'none', // Remove underline in standard variant
                              },
                              '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                                borderBottom: 'none', // Remove hover effect
                              },
                              '& .MuiInput-underline:after': {
                                borderBottom: 'none', // Remove underline for focused state
                              },
                              '& fieldset': { border: 'none' },
                            }}
                            placeholder={'Search'}
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                              style: { color: 'black' },
                            }}
                            // onFocus={(e) => {
                            //   // When the input is focused, change the label to empty
                            //   e.target.placeholder = ""; // Remove placeholder text on focus if needed
                            // }}
                            // onBlur={(e) => {
                            //   // When the input loses focus, revert changes if necessary
                            //   e.target.placeholder = filterColumns.Status
                            //     ? ""
                            //     : "Search"; // Revert placeholder text on blur if needed
                            // }}
                            {...params}
                          />
                        )}
                      />
                      <IconButton type="button" sx={{ p: '0px' }}>
                        {filterColumns.Status !== '' ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                Status: '',
                              }));
                              setFilteredList(rows);
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <DateRangeRsuite
                        ref={DateRangeRef}
                        value={[
                          filterColumns.DueDateFrom ? filterColumns.DueDateFrom : null,
                          filterColumns.DueDateTo ? filterColumns.DueDateTo : null,
                        ]}
                        onChange={({ from, to }) => {
                          setFilterColumns((prev) => ({
                            ...prev,
                            DueDateFrom: from ? from : '',
                            DueDateTo: to ? to : '',
                          }));
                        }}
                        className="hide-input-outline hide-input-border"
                      />
                      {/* <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.DueDateFrom !== '' || filterColumns.DueDateTo != '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  DueDateFrom: '',
                                  DueDateTo: '',
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton> */}
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: '2px 4px',

                        width: '100%',
                      }}
                    >
                      <Stack direction={'row'} height={'32px'} gap="5px">
                        <MoneyTextFieldRange
                          value={[filterColumns.AmountFrom, filterColumns.AmountTo]}
                          onChange={(e) => {
                            filterBySearch(e, 'GrandTotalAmount', e);
                          }}
                        />

                        <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.AmountFrom !== '' || filterColumns.AmountTo !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  AmountFrom: '',
                                  AmountTo: '',
                                }));
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Stack>
                    </Paper>
                  </TableCell>
                  {/* <TableCell>
                      <Paper
                        sx={{
                          p: "2px 4px",
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <InputBase
                          name="balanceDue"
                          value={filterColumns.balanceDueAmount}
                          onChange={(e) => filterBySearch(e, "BalanceDueAmount")}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ p: "0px" }}>
                          {filterColumns.balanceDueAmount !== "" ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  balanceDueAmount: "",
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell> */}
                  <TableCell>
                    <Paper
                      sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <InputBase
                        name="overDueDays"
                        value={filterColumns.overDueDays}
                        onChange={(e) => filterBySearch(e, 'overDueDays')}
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: '0px' }}>
                        {filterColumns.overDueDays !== '' ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                overDueDays: '',
                              }));
                              setFilteredList(rows);
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  <TableCell className="actionBackGround" sx={{ backgroundColor: 'transparent !important' }}></TableCell>
                </TableRow>
                {filteredList.length > 0 ? (
                  filteredList
                    .slice(page * rowsPerPageRef.current, page * rowsPerPageRef.current + rowsPerPageRef.current)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.crdrnoteid);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      let status = row.statuscd;
                      switch (status) {
                        case 'Paid':
                          status = (
                            <Typography
                              sx={{
                                color: row.cancelflag === 1 ? 'gray' : '#009933',
                                opacity: row.cancelflag === 1 ? 0.5 : 1,
                                fontSize: '13px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <CheckCircleIcon
                                sx={{
                                  color: row.cancelflag === 1 ? 'gray' : '#009933',
                                  opacity: row.cancelflag === 1 ? 0.5 : 1,
                                  fontSize: '15px',
                                  marginRight: '5px',
                                }}
                              />{' '}
                              {row.statuscd}
                            </Typography>
                          );
                          break;
                        case 'Unpaid':
                          status = (
                            <Typography
                              sx={{
                                color: row.cancelflag === 1 ? 'gray' : '#eb4141',
                                opacity: row.cancelflag === 1 ? 0.5 : 1,
                                fontSize: '13px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <ErrorIcon
                                sx={{
                                  color: row.cancelflag === 1 ? 'gray' : '#eb4141',
                                  opacity: row.cancelflag === 1 ? 0.5 : 1,
                                  fontSize: '15px',
                                  marginRight: '5px',
                                }}
                              />{' '}
                              {row.statuscd}
                            </Typography>
                          );
                          break;
                        case 'Partial':
                          status = (
                            <Typography
                              sx={{
                                color: row.cancelflag === 1 ? 'gray' : '#6096d9',
                                opacity: row.cancelflag === 1 ? 0.5 : 1,
                                fontSize: '13px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <RunningWithErrorsIcon
                                sx={{
                                  color: row.cancelflag === 1 ? 'gray' : '#6096d9',
                                  opacity: row.cancelflag === 1 ? 0.5 : 1,
                                  fontSize: '15px',
                                  marginRight: '5px',
                                }}
                              />{' '}
                              {row.statuscd}
                            </Typography>
                          );
                          break;

                        default:
                          break;
                      }
                      let currencySymbol = '₹'; //billingCurrencyOptions.find((elem) => row.CurrencyCode == elem.value)?.sign

                      return (
                        <TableRow
                          hover
                          // onClick={(event) => handleClick(event, row.voucherNo)}
                          onClick={(event) => {
                            dispatch(updateTitle(row.crdrnotenumber));
                            // dispatch(
                            //   updateViewTitle(
                            //     row.cancelflag == 1
                            //       ? {
                            //         type: "Cancelled",
                            //         name: row.crdrnotenumber,
                            //       }
                            //       : { type: "", name: row.crdrnotenumber }
                            //   )
                            // );
                            navigate('/viewcreditnote', {
                              state: {
                                id: row.crdrnoteid,
                                view: true,
                              },
                            });
                          }}
                          className={row.cancelflag === 1 ? 'rowInactiveMuted' : ''}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={index}
                          selected={isItemSelected}
                          style={{ cursor: 'pointer' }}
                          sx={{
                            '.MuiTableCell-root': {
                              backgroundColor: 'transparent ',
                              borderBottom: 'none',
                            },
                          }}
                        >
                          <TableCell
                            padding="checkbox"
                            sx={{
                              '.css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root': {
                                padding: '5px',
                              },
                            }}
                          >
                            <Checkbox
                              color="primary"
                              onClick={(event) => {
                                event.stopPropagation();
                              }}
                              onChange={(event) => {
                                event.stopPropagation();
                                handleClick(event, row);
                              }}
                              checked={isItemSelected}
                              inputProps={{
                                'aria-labelledby': labelId,
                              }}
                              size="small"
                            />
                          </TableCell>
                          <TableCell
                            // component="th"
                            id={labelId}
                            scope="row"
                            // padding="none"
                            title={row.cancelflag === 1 ? 'Cancelled' : ''}
                          >
                            {formatUnixTimestamp(row.crdrnotedate)}
                          </TableCell>
                          <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} align="left">
                            {/* <MUILink
                                underline="hover"
                                sx={{ cursor: "pointer" }}
                              > */}
                            <a
                              className="myLink"
                              href={`/viewcreditnote/${row.crdrnotenumber}?transaction=${row.crdrnoteid}`}
                              target="_blank"
                              rel="noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {row.crdrnotenumber}
                            </a>
                            {/* </MUILink> */}
                          </TableCell>
                          {/* {click==false? */}
                          <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} sx={{}} align="left">
                            {/* {row.partyinvoicenumber} */}

                            <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {row.partyinvoicenumber?.split(',').map((num, i) => (
                                <React.Fragment key={i}>
                                  <a
                                    className="myLink"
                                    rel="noreferrer"
                                    onClick={(e) => e.stopPropagation()}
                                    href={
                                      row.customerorsuppliertype === 'SUPPLIER'
                                        ? `/viewnewpurchasetax/${num.trim()}?transaction=${row.originalinvoicenumber}`
                                        : `/viewnewinvoicetax/${num.trim()}?transaction=${row.originalinvoicenumber}`
                                    }
                                    target="_blank"
                                  >
                                    {num.trim()}
                                  </a>
                                  {i < row.partyinvoicenumber.split(',').length - 1 && ', '}
                                </React.Fragment>
                              ))}
                            </span>

                            {/* {clickable == index
                                  ? row.InvNo.join(",")
                                  : row.InvNo.slice(0, 10).join(",")}

                                {row.InvNo.length > 1 ? (
                                  <FormControlLabel
                                    sx={{
                                      ".css-i4bv87-MuiSvgIcon-root ": {
                                        height: "10px",
                                      },
                                      ".css-ahj2mt-MuiTypography-root": {
                                        fontSize: "10px",
                                        color: "input.label",
                                      },
                                    }}
                                    checked={clickable === index ? true : false}
                                    control={<Checkbox />}
                                    label="...Show more items "
                                    size="small"
                                    onChange={(event) => {
                                      event.stopPropagation();
                                      if (clickable === index) {
                                        setClickable(null);
                                      } else {
                                        setClickable(index);
                                      }
                                    }}
                                  />
                                ) : (
                                  ""
                                )} */}
                          </TableCell>
                          <TableCell
                            title={row.cancelflag === 1 ? 'Cancelled' : ''}
                            onClick={() => {
                              dispatch(updateTitle(row.crdrnotenumber));
                              // e.stopPropagation();
                            }}
                            align="left"
                            sx={{
                              maxWidth: '150px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {' '}
                            {/* <Link
                                  underline="hover"
                                  style={{
                                    color: theme.palette.text.Link,
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();

                                    navigate(
                                      row.customerOrSupplierType === "SUPPLIER"
                                        ? "/viewsupplier"
                                        : "/viewcustomer",
                                      {
                                        state: {
                                          id: row.PartyID,
                                          view: true,
                                        },
                                      }
                                    );
                                  }}
                                > */}
                            <Tooltip title={row.partydisplayname} placement="right">
                              <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                <a
                                  className="myLink"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                  href={
                                    row.customerorsuppliertype === 'SUPPLIER'
                                      ? `/viewsupplier?id=${row.partyid}&view=true&title=${row.partydisplayname}`
                                      : `/viewcustomer?id=${row.partyid}&view=true&title=${row.partydisplayname}`
                                  }
                                  target="_blank"
                                >
                                  {row.partydisplayname}
                                </a>
                              </span>
                            </Tooltip>
                            {/* </Link> */}
                          </TableCell>
                          <TableCell
                            title={row.cancelflag === 1 ? 'Cancelled' : ''}
                            align="left"
                            sx={{
                              fontSize: '13px',
                              color: row?.partamount >= row.grandtotalamount ? '#009933' : row?.partamount == 0 ? '#eb4141' : '#6096d9',
                              opacity: row.cancelflag === 1 ? 0.5 : 1,
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}> {status}</Box>
                          </TableCell>
                          <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} align="left" sx={{ whiteSpace: 'nowrap' }}>
                            {row.dueDate}
                          </TableCell>
                          <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} align="right">
                            <a
                              underline="hover"
                              style={{
                                color: theme.palette.text.Link,
                                cursor: 'pointer',
                              }}
                              href={`/LedgerTransactions/${row?.partyaccountid}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                dispatch(updateTitle(row.crdrnotenumber));
                                e.preventDefault();
                                if (row?.partyaccountid !== '') {
                                  // localStorage.removeItem('IsLedgerViewModalOpen')
                                  // setBackdropOpen(true);
                                  // setAccountName(row.partydisplayname);
                                  setAccountID(row?.partyaccountid);
                                  // getModalData(row?.PartyAccountID);
                                }
                              }}
                            >
                              {currencySymbol} {MoneyFormatv3(row.grandtotalamount, 'en-IN')}
                            </a>
                          </TableCell>
                          {/* <TableCell align="left">
                              {MoneyFormatv3(row.BalanceDueAmount, "en-IN")}
                            </TableCell> */}
                          <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} align="right">
                            <Box>
                              {row.paymentclearedflag === 1 && row.statuscd !== 'Partial' ? (
                                0
                              ) : row.statuscd === 'Paid' ? (
                                '-'
                              ) : (
                                <span
                                  style={{
                                    color: row.cancelflag === 1 ? 'gray' : row.overduedays < 0 ? 'red' : 'green',
                                    opacity: row.cancelflag === 1 ? 0.5 : 1,
                                  }}
                                >
                                  {Math.abs(row.overduedays)}&nbsp;
                                  {row.statuscd === 'Paid' ? '' : Math.abs(row.overduedays) == 1 ? 'day' : 'days'}
                                </span>
                              )}
                            </Box>
                          </TableCell>
                          <TableCell className="actionBackGround" align="center" sx={{position :!showActions ? 'relative' : 'sticky'}}>
                            <Box className="actionCellStyle">
                              <Tooltip title={'Download PDF'} placement="left" disableInteractive arrow>
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    checkandopenpdf(row.crdrnotepdf);
                                  }}
                                  aria-label="delete"
                                  sx={{
                                    margin: '0px 2px',
                                    padding: '5px',
                                    backgroundColor: '#c5d6dc',
                                    border: 'solid 1px black',
                                  }}
                                >
                                  <img src={pdfImage} height={10} alt="Download" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={'Print'} placement="top" disableInteractive arrow>
                                <IconButton
                                  disableRipple
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    fetchAndPrintPDF(row.crdrnotepdf);
                                  }}
                                  aria-label="delete"
                                  sx={{
                                    margin: '0px 2px',
                                    padding: '5px',
                                    backgroundColor: '#c5d6dc',
                                    border: 'solid 1px black',
                                  }}
                                >
                                  <LocalPrintshop
                                    sx={{
                                      fontSize: '10px',
                                      color: '#36454f',
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                              {/* {row.cancelflag !== 1 && ( */}
                              <Tooltip title={row.cancelflag === 1 ? 'cannot Edit' : 'Edit'} placement="left" disableInteractive arrow>
                                <IconButton
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    if (Freeze == 1) {
                                      return handleFreeze();
                                    }
                                    if (row.cancelflag === 1) {
                                      return;
                                    }
                                    dispatch(updateTitle(row.crdrnotenumber));
                                    localStorage.removeItem('CreditNoteID');
                                    localStorage.removeItem('CreditNoteViewMode');
                                    navigate('/editcreditnote', {
                                      state: {
                                        id: row.crdrnoteid,
                                        pdflink: row.crdrnotepdf,
                                      },
                                    });
                                  }}
                                  aria-label="delete"
                                  sx={{
                                    margin: '0px 2px',
                                    padding: '5px',
                                    backgroundColor: '#D0EFFF',
                                    border: 'solid 1px black',
                                  }}
                                >
                                  {row.cancelflag === 1 ? (
                                    <EditOff sx={{ fontSize: '10px', color: '#6096d9' }} />
                                  ) : (
                                    <EditIcon
                                      sx={{
                                        fontSize: '10px',
                                        color: '#6096d9',
                                      }}
                                    />
                                  )}
                                </IconButton>
                              </Tooltip>
                              {/* )} */}
                              <Tooltip title={'Share'} placement="left" disableInteractive arrow>
                                <IconButton
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    // For individual Share, use separate state
                                    // that doesn't interfere with bulk selection
                                    setIndividualEmailSelection([
                                      {
                                        crdrnoteid: row.crdrnoteid,
                                        partyid: row.partyid,
                                        partyemail: row.partyemail,
                                        consigneename: row.partydisplayname,
                                        crdrnotenumber: row.crdrnotenumber,
                                      },
                                    ]);
                                    setShareOpen(row.crdrnotepdf);
                                  }}
                                  aria-label="delete"
                                  sx={{
                                    margin: '0px 2px',
                                    padding: '5px',
                                    backgroundColor: '#E8F5E9',
                                    border: 'solid 1px black',
                                    // backgroundColor: '#b1d1f97d'
                                  }}
                                >
                                  <Share
                                    sx={{
                                      fontSize: '10px',
                                      color: '#388E3C',
                                      // color: '#6096d9'
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>

                              {/* <ThreeDot
                                    onEdit={
                                      row.ExpiredTimeStamp != 0 ||
                                        row.CancelFlag == 1
                                        ? null
                                        : (event) => {
                                          event.stopPropagation();
                                          dispatch(
                                            updateTitle(row.CrDrNoteNumber)
                                          );
                                          localStorage.removeItem("CreditNoteID");
                                          localStorage.removeItem(
                                            "CreditNoteViewMode"
                                          );
                                          navigate("/editcreditnote", {
                                            state: { id: row.CrDrNoteID },
                                          });
                                        }
                                    }
                                    onDelete={
                                      row.ExpiredTimeStamp === 0
                                        ? (event) => {
                                          event.stopPropagation();
                                          setDeleteModalStatus(true);
                                          setItemData({
                                            id: row.CrDrNoteID,
                                            ind: index,
                                          });
                                        }
                                        : null
                                    }
                                    onView={(event) => {
                                      event.stopPropagation();
                                      dispatch(updateTitle(row.CrDrNoteNumber));
                                      navigate("/viewcreditnote", {
                                        state: {
                                          id: row.CrDrNoteID,
                                          view: true,
                                        },
                                      });
                                    }}
                                    onCancel={
                                      row.ExpiredTimeStamp != 0 ||
                                        row.CancelFlag == 1
                                        ? null
                                        : (event) => {
                                          event.stopPropagation();
                                          dispatch(
                                            updateTitle(row.CrDrNoteNumber)
                                          );
                                          setWarningOpen({
                                            render: (
                                              <Box>
                                                <Typography>
                                                  Are you sure you want to cancel
                                                  this Credit Note ?
                                                </Typography>
                                                <Typography
                                                  component={"p"}
                                                  sx={{ fontSize: "smaller" }}
                                                >
                                                  <br />
                                                  <b>NOTE : All the payments linked with this credit note will be cancelled immediately.<br />You can't undo
                                                    this action.</b>
                                                </Typography>
                                                <Box sx={{ marginTop: "8px" }}>
                                                  <TeaxtareaField
                                                    name="reason"
                                                    placeholder="Reason for Cancellation"
                                                    size="small"
                                                    fullWidth
                                                    rows={6}
                                                    state={state}
                                                    // value={state.reason}
                                                    onChange={(e) => {
                                                      if (
                                                        e.target.value.length >
                                                        250
                                                      ) {
                                                        setState((prev) => ({
                                                          ...prev,
                                                          ["reason"]:
                                                            e.target.value,
                                                          ["errorStatus"]: {
                                                            ...prev.errorStatus,
                                                            ["reason"]: true,
                                                          },
                                                          ["errorFields"]: {
                                                            ...prev.errorFields,
                                                            ["reason"]:
                                                              "Reason for Cancellation must be less than 250 characters",
                                                          },
                                                        }));
                                                      } else if (
                                                        e.target.value.length <= 0
                                                      ) {
                                                        setState((prev) => ({
                                                          ...prev,
                                                          ["reason"]:
                                                            e.target.value,
                                                          ["errorStatus"]: {
                                                            ...prev.errorStatus,
                                                            ["reason"]: true,
                                                          },
                                                          ["errorFields"]: {
                                                            ...prev.errorFields,
                                                            ["reason"]:
                                                              "Reason for Cancellation is Required",
                                                          },
                                                        }));
                                                      } else {
                                                        setState((prev) => ({
                                                          ...prev,
                                                          reason: e.target.value,
                                                          ["errorStatus"]: {
                                                            ...prev.errorStatus,
                                                            ["reason"]: false,
                                                          },
                                                          ["errorFields"]: {
                                                            ...prev.errorFields,
                                                            ["reason"]: "",
                                                          },
                                                        }));
                                                      }
                                                    }}
                                                  />
                                                </Box>
                                              </Box>
                                            ),
                                            onContinue: async () => {
                                              await cancel(row.CrDrNoteID);
                                            },
                                            onCancel: () => { },
                                          });
                                        }
                                    }
                                  /> */}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                ) : circularOpen == false && rows.length <= 0 && !dataCount > 0 ? (
                  <TableRow>
                    <TableCell height={400} align="center" colSpan={11}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                ) : (
                  ''
                )}
                {circularOpen == true &&
                  limit > 0 &&
                  Array.from({ length: limit }, (_, index) => (
                    <TableRow key={index}>
                      <TableCell colSpan={12}>
                        <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          {dataCount > 0 && (
            <TablePagination
              sx={{
                scrollbarWidth: 'thin',
                '&::-webkit-scrollbar': {
                  // width: '0.4em',
                  height: '0.4em',
                },
                '&::-webkit-scrollbar-track': {
                  background: `${theme.palette.primary.main}47`,
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'primary.main',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: `${theme.palette.primary.main}47`,
                },
              }}
              // rowsPerPageOptions={[5, 10, 25,{ label: 'All', value: -1 }]}
              rowsPerPageOptions={defaultRowsPerPageOptions}
              component="div"
              count={dataCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Box>

        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
          <CircularProgress color="inherit" />
        </Backdrop>
        {shareOpen ? (
          <ShareModal
            open={shareOpen}
            setOpen={setShareOpen}
            text={'Credit'}
            emailData={{
              selectedRow: individualEmailSelection?.map((note) => ({
                id: Number(note.crdrnoteid),
                recipientId: Number(note.partyid),
                email: note.partyemail,
                name: note.partydisplayname,
                invoiceNumber: note.crdrnotenumber,
              })),
              type: 'creditNote',
            }}
          />
        ) : null}
        {/* <ExportData
            setOpen={setExportModalOpen}
            open={exportModalOpen}
            item={exportItem}
          /> */}
        {WarningModal}
      </Box>
      <LedgerTransactionModalv2 open={accountID} accountId={accountID} onClose={() => setAccountID('')} />
      <SendEmailModalWrapper {...modalProps} />
    </Box>
  );
}

export default AllCreditNote;
